import vueResource from 'vue-resource'
import merge from 'lodash/merge'

export default {
    install(Vue, options)
    {


    }
}